import React from 'react';
import { M130 } from './m130-newsletter';
import {IM130NewsletterModule} from "~/lib/data-contract";

export const M130NewsletterBlock = ({id, apsisFormId }: IM130NewsletterModule & { apsisFormId?: string }) => {
    return <M130 id={id} apsisFormId={apsisFormId} />;
};
